import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useProjectionCashEventSettings, useUpdateProjectionCashEventItemSettings, useUpdateProjectionCashEventSettings } from '../../api';
import { CashOccurrenceType } from '../../enums';
import { CashflowSettingBox } from '../settings-drawer';

export const OneOffCashflowSettings: FunctionComponent = () => {
    const { t } = useTranslation();
    const { data: cashEventsSettings } = useProjectionCashEventSettings();

    const updateCashEventSettings = useUpdateProjectionCashEventSettings();
    const updateCashEventItem = useUpdateProjectionCashEventItemSettings();

    return (
        <CashflowSettingBox
            title={t('oneOffCashflows')}
            cashOccurrenceType={CashOccurrenceType.ONE_OFF}
            settings={cashEventsSettings}
            updatePanelSettings={updateCashEventSettings}
            updateItemSettings={updateCashEventItem}
        />
    );
};
